// extracted by mini-css-extract-plugin
module.exports = {"myProj":"Overview_myProj__Ahbbu"};